import { render, staticRenderFns } from "./UnidadMedidaCompraSelectComponent.vue?vue&type=template&id=bc5858e0&"
import script from "./UnidadMedidaCompraSelectComponent.vue?vue&type=script&lang=js&"
export * from "./UnidadMedidaCompraSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports